import { useQuery, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export const getCommentsTable = async () => {
  try {
    const url = `${baseUrl}/aws/comments`
    const { data } = await axios.get(url, {
      params: { table: 'COMMENTS_TABLE' }, // Params are only needed for fetching all items
    })
    // console.log('response?.data', data)
    return data || []
  } catch (error) {
    console.error('Error fetching data:', error)
    return [] // Return an empty array in case of an error
  }
}

export const useCommentsTable = (enabled?: boolean, _queryKey?: [string, string]) => {
  const queryClient = useQueryClient()
  const queryData = queryClient.getQueryData(['commentsTable'])
  const { data: commentsTable, isLoading: isCommentsTableLoading, isError: isCommentsTableError } = useQuery({
    queryKey: ['commentsTable'],
    queryFn: getCommentsTable,
    staleTime: 1000 * 60 * 10, // Keeps data fresh for 10 minutes
    enabled: !queryData || enabled || false,
  })

  return {
    commentsTable,
    isCommentsTableLoading,
    isCommentsTableError,
  }
}
